import * as types from './constants';

// Accept Invitation Sign Up
export const acceptInvitationSignUpRequest = data => (
  { type: types.ACCEPT_INVITATION_SIGN_UP_REQUEST, payload: data }
);

export const acceptInvitationSignUpDone = data => (
  { type: types.ACCEPT_INVITATION_SIGN_UP_DONE, payload: data }
);

export const acceptInvitationSignUpFailed = errors => (
  { type: types.ACCEPT_INVITATION_SIGN_UP_FAILED, payload: errors }
);